import Observer from '../../../common/scripts/observer';
import {TABLET_BREAKPOINT} from '../../../common/scripts/constants';
import {Utils} from '../../../common/scripts/utils';

const observer = new Observer();

class CustomSelect {
    /* eslint-disable max-statements */
    constructor(options) {
        this.options = options;
        this.elem = Utils.isElement(options.elem) ? options.elem : document.querySelector(options.elem);

        if (!this.elem) {
            console.error(`Element with selector "${options.elem}" not found!`);

            return;
        }

        this.inputSelector = '.j-custom-select__input';
        this.contentSelector = '.j-custom-select__content';
        this.valueSelector = '.j-custom-select__value';
        this.checkSelector = '.j-custom-select__checkbox';
        this.itemsWrapSelector = '.j-custom-select__items';
        this.singleClass = 'is-single';
        this.openClass = 'is-open';
        this.checkedClass = 'is-checked';
        this.disableClass = 'is-disabled';
        this.specialClass = 'j-special-select';

        this.isOpen = false;
        this.isSingleSelect = false;
        this.summaryPrefix = ['Выбран:', 'Выбрано:', 'Выбрано:'];
        this.isMobile = this._setIsMobile();
        this.isSpecial = this.checkIfSpecial() || null;

        this._clickOutside = this._clickOutside.bind(this);
    }

    init() {
        if (!this.elem) {
            return;
        }

        this._toggleFix = this._toggleFix.bind(this);
        this._initElements();
        this._getDataset();

        if (this.elem.classList.contains(this.openClass)) {
            this.open();
        } else {
            this.close();
        }

        if (this.elem.classList.contains(this.singleClass)) {
            this.isSingleSelect = true;
        }

        this._bindEvents();
        this._changeValue();
    }

    /**
     * Инит элементов
     * @private
     */
    _initElements() {
        this.input = this.elem.querySelector(this.inputSelector);
        this.content = this.elem.querySelector(this.contentSelector);
        this.value = this.elem.querySelector(this.valueSelector);
        this.checks = Array.from(this.elem.querySelectorAll(this.checkSelector));
        this.itemsWrap = this.elem.querySelector(this.itemsWrapSelector);
    }

    /**
     * Берет данные из data-атрибутов
     * @private
     */
    _getDataset() {
        const {placeholder, suffix, prefix, valueType} = this.elem.dataset;

        this.placeholder = placeholder;
        this.suffix = suffix;
        this.prefix = prefix;
        this.valueType = valueType;
    }

    /**
     * Вешает обработчики событий
     * @private
     */
    _bindEvents() {
        const events = ['resize', 'orientationchange'];

        events.forEach((event) => {
            window.addEventListener(event, () => {
                this.isMobile = this._setIsMobile();
                if (this.isOpen) {
                    this.close();
                }
            });
        });

        this.input.addEventListener('click', () => {
            if (this.isOpen) {
                this.close();
            } else {
                this.open();
            }
        });

        // Чек опшенов
        this.checks.forEach((check) => {
            check.addEventListener('change', () => {
                if (this.isSingleSelect) {
                    this._emptyChecks(check);
                    this._changeValue();
                    this._removeValidateErrorClasses();
                    this.close();
                } else {
                    this._changeValue();
                }
            });
        });
    }

    checkIfSpecial() {
        return this.elem.classList.contains(this.specialClass);
    }

    _setIsMobile() {
        return Utils.getWindowWidth() < TABLET_BREAKPOINT;
    }

    /**
     * Открыть выпадающий список
     */
    open() {
        document.addEventListener('click', this._clickOutside);
        this.isOpen = true;
        this.elem.classList.add(this.openClass);
        this.content.style.height = `${this.content.scrollHeight}px`;
        this._fixBody();
    }

    /**
     * Закрыть выпадающий список
     */
    close() {
        document.removeEventListener('click', this._clickOutside);
        this.isOpen = false;
        this.content.style.height = '0px';
        setTimeout(() => {
            this.content.style.height = '';
        }, 300);
        this.elem.classList.remove(this.openClass);
        this._unfixBody();
    }

    _fixBody() {
        if (!this.isMobile) {
            return;
        }

        Utils.bodyStatic();
        Utils.bodyFixed(this.itemsWrap);
        this._bindResize();
    }

    _unfixBody() {
        if (!this.isMobile) {
            return;
        }

        Utils.bodyStatic();
        this._unbindResize();
        observer.publish('custom-select:close');
    }

    /**
     * Вешает обработчики на резайз и изменение ориентации
     * @private
     */
    _bindResize() {
        window.addEventListener('resize', this._toggleFix);
        window.addEventListener('orientationchange', this._toggleFix);
    }

    /**
     * Снимает ресайз-обработчики
     * @private
     */
    _unbindResize() {
        window.removeEventListener('resize', this._toggleFix);
        window.removeEventListener('orientationchange', this._toggleFix);
    }

    _toggleFix() {
        if (!this.isMobile && this.isOpen) {
            this._unfixBody();
        }
    }

    /**
     * Ловит клик снаружи элемента
     * @param {object} event - объект события клика
     * @private
     */
    _clickOutside(event) {
        if (!event && !event.target) {
            return;
        }

        if (!Utils.isDescendant(event.target, this.elem)) {
            this.close();
        }
    }

    /**
     * Оставляет чекнутым только тот чекбокс, который выбираем
     * @param {Element} check - элемент чекбокса
     * @private
     */
    _emptyChecks(check) {
        const checkedArr = Array.from(this.elem.querySelectorAll(`${this.checkSelector}:checked`));

        if (checkedArr.length > 1) {
            checkedArr.filter((item) => {
                // eslint-disable-next-line no-return-assign
                return item.checked = item === check;
            });
        }
    }

    /**
     * Выводит список выбранного
     * @private
     */
    _changeValue() {
        const text = this.valueType === 'summary' ? this._getSummary() : this._collectText();

        this._insertTextValue(text);
        this.checkIfSpecial();

        observer.publish('custom-select:change');

        if (this.isSpecial) {
            this.close();
            observer.publish('custom-select:instant-close', text);
        }
    }

    /**
     * Возвращает строку-список выбранного в формате "Выбрано Х элементов"
     * НЕ ДОРАБОТАНО ДЛЯ ГРУПП ЧЕКБОКСОВ !!!
     * @return {string|*} - итоговая строка
     * @private
     */
    _getSummary() {
        const len = Array.from(this.elem.querySelectorAll(`${this.checkSelector}:checked`)).length;

        if (!len) {
            return this.placeholder;
        }

        const suffix = this.suffix ? Utils.pluralWord(len, this.suffix.split('|')) : '';

        return `${Utils.pluralWord(len, this.summaryPrefix)} ${len} ${suffix}`;
    }

    /**
     * Собирает список выбранного из названий (через запятую)
     * @return {string|*} - итоговая строка
     * @private
     */
    _collectText() {
        let finalText = '';

        for (let i = 0; i < this.checks.length; i++) {
            const check = this.checks[i];

            if (check.checked && check.value === 'reset') {
                finalText = '';

                return this.placeholder;
            }

            finalText = this._getItemsText(check, finalText);
        }

        finalText = finalText.substr(2);

        if (!finalText) {
            return this.placeholder;
        }

        return `${this.prefix ? `${this.prefix} ` : ``}${finalText}`;
    }

    /**
     * Получает текст чекбокса для вывода в строку результатов
     * @param {Element} item - элемент чекбокса
     * @param {string} str - строка, к которой нужно приклеить текст чекбокса
     * @param {boolean} forceGet - true - учитывать чекбокс даже если он не чекнут
     * @return {string|*} - итоговая строка
     * @private
     */
    _getItemsText(item, str, forceGet = false) {
        if (!item.checked && !forceGet) {
            return str;
        }

        const dataText = item.dataset.text;
        let itemText = `, ${dataText}`;

        if (!this.suffix) {
            return str + itemText;
        }

        let finalText = str;

        // Первый символ отмеченного - цифра
        // Подходит для комнат/этажей
        if (!isNaN(Number(dataText.slice(0, 1)))) {
            finalText = str.endsWith(this.suffix) ? str.slice(0, str.length - this.suffix.length) : str;
            itemText = itemText + this.suffix;
        }

        return finalText + itemText;
    }

    /**
     * Подставляет текстовое значение в инпут с результатами выбора
     * @param {string} text - текст, который нужно вставить
     * @private
     */
    _insertTextValue(text) {
        Utils.clearHtml(this.value);
        Utils.insetContent(this.value, text);
    }

    /**
     * Возвращает список чекбоксов в формате объекта
     * @return {{checked: boolean, disabled: boolean, value: *}[]} - чекнут ли, задисейблен ли, значение
     */
    getOptions() {
        return this.checks.map((check) => {
            return {
                value   : check.value,
                checked : Boolean(check.checked),
                disabled: Boolean(check.disabled)
            };
        });
    }

    /**
     * Обновляет селект снаружи
     * @param {Object} options - переданные опции
     */
    update(options) {
        // Обновляем опции
        options.forEach((option) => {
            this.checks.forEach((elem) => {
                if (elem.name === option.name) {
                    elem.checked = option.checked;
                    elem.disabled = option.disabled;
                }
            });
        });
        // Обновляем текст
        this._changeValue();
    }

    _removeValidateErrorClasses() {
        this.elem?.classList?.remove('validate-input-error');
        this.elem?.classList?.remove('is-error');

        Array.from(this.elem.querySelectorAll('.input__error-text')).forEach((input) => {
            if (input.style && input.style.display) {
                input.style.display = 'none';
            }
        });
    }
}

export default CustomSelect;
